import { render } from "./LanguageCreateComponent.vue?vue&type=template&id=25891e63"
import script from "./LanguageCreateComponent.vue?vue&type=script&lang=js"
export * from "./LanguageCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Language/LanguageCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25891e63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25891e63', __exports__)) {
    api.reload('25891e63', __exports__)
  }
  
  module.hot.accept("./LanguageCreateComponent.vue?vue&type=template&id=25891e63", () => {
    api.rerender('25891e63', render)
  })

}


export default __exports__